import React from "react";
import Card from "../../../components/card/Card";
import ModalMsg from "../../../components/ModalMsg";
import NsScrollableTabs from "../../../components/NsScrollableTabs";
import ModalDocumentoKpiController from "./components/ModalDocumentoKpiController";
import ModalCommentoKpiController from "../../../features/commenti/ModalCommentoKpiController";

export default function InfoKpiView({
                                        kpi,
                                        id,
                                        history,
                                        translate,
                                        keyTab,
                                        setKeyTab,
                                        idTipoImport,
                                        setShowModalCommentoKpi,
                                        setShowModalDocumentoKpi,
                                        show,
                                        setShow,
                                        modalMsg,
                                        scrollableTabs,
                                        showModalDocumentoKpi,
                                        showModalCommentoKpi,
                                        handleOkModalDocumento,
                                        handleOkModalCommento,
                                    }) {

    return (
        <Card
        title={`${kpi.codice} - ${translate(kpi.descrizione)} (` + (translate(kpi.tipo_imp_dati) || '') + `)`}
        bottoniSx={[{
            icon: 'fas fa-angle-left', command: () => {
                history.goBack();
            }
        }]}
        bottoniDx={[(keyTab === 0) && kpi && (kpi.scrittura == '1' || kpi.approvazione || kpi.revisione || kpi.configurazione) && {
            label: translate("Modifica"), icon: "fas fa-pen", command: () => {
                history.push(`/upd-dati-kpi/${id}/${idTipoImport}`);
            }
        }, (keyTab === 1) && {
            label: translate("Aggiungi Commento"), icon: "fas fa-plus-circle", command: () => {
                setShowModalCommentoKpi(true);
            }
        }, (keyTab === 2) && {
            label: translate("Caricamento documenti"), icon: "fas fa-plus-circle", command: () => {
                setShowModalDocumentoKpi(true);
            }
        }]}
    >
        <ModalMsg
            show={show}
            handleClose={() => {
                setShow(false);
            }}
            testo={modalMsg}/>
        <NsScrollableTabs
            activeIndex={keyTab}
            onTabChange={(e) => setKeyTab(e.index)}
            scrollableTabs={scrollableTabs}
        />
        <ModalDocumentoKpiController
            idKpi={id}
            idTipoImport={idTipoImport}
            show={showModalDocumentoKpi}
            handleClose={() => setShowModalDocumentoKpi(false)}
            handleOk={handleOkModalDocumento}
        />
        <ModalCommentoKpiController
            idKpi={id}
            idTipoImport={idTipoImport}
            show={showModalCommentoKpi}
            handleClose={() => setShowModalCommentoKpi(false)}
            handleOk={handleOkModalCommento}
        />
    </Card>);
}